import { createContext, useCallback, useContext, useRef, useSyncExternalStore } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const createContextFactory = ({
  initialState,
  loggerOn = false,
  contextName
}) => {
  const useStoreData = () => {
    const store = useRef(initialState);
    const get = useCallback(() => store.current, []);
    const subscribers = useRef(new Set());
    const set = useCallback(value => {
      store.current = Object.assign({}, store.current, value);
      subscribers.current.forEach(callback => callback());
    }, []);
    const subscribe = useCallback(callback => {
      subscribers.current.add(callback);
      return () => subscribers.current.delete(callback);
    }, []);
    return {
      get,
      set,
      subscribe
    };
  };
  const StoreContext = /*#__PURE__*/createContext(null);
  const Provider = ({
    children
  }) => {
    return /*#__PURE__*/_jsx(StoreContext.Provider, {
      value: useStoreData(),
      children: children
    });
  };
  const useGetStore = selector => {
    const store = useContext(StoreContext);
    if (!store) {
      throw new Error('Store not found');
    }
    const state = useSyncExternalStore(store.subscribe, () => selector(store.get()), () => selector(initialState));
    return state;
  };
  const useSetStore = () => {
    const store = useContext(StoreContext);
    if (!store) {
      throw new Error('Store not found');
    }
    return value => {
      const prevState = store.get();
      store.set(value);
      const nextState = store.get();
      if (loggerOn) {
        console.group(`${contextName} state change`);
        console.trace();
        console.log('Previous state:', prevState);
        console.log('Next state:', nextState);
        console.groupEnd();
      }
    };
  };
  return {
    Provider,
    useGetStore,
    useSetStore
  };
};